import { mount } from "svelte";

import "@steyncd/steyn-design/index.css";
// Form primitives shared by Docs and FileTab. Global on purpose — see forms.css.
import "./forms.css";
import App from "./App.svelte";
import { applyTheme } from "./lib/appearance";

// Which build is this? Printed once, and readable as window.__BUILD__ — the
// answer to "did my fix actually reach the browser, or am I on a cached shell?"
(window as unknown as { __BUILD__: string }).__BUILD__ = `${__BUILD_SHA__} ${__BUILD_AT__}`;
console.info(`build ${__BUILD_SHA__} · ${__BUILD_AT__}`);

// Theme comes from Fabric's registry, not from this bundle: the household
// asked for per-portal control, and a colour change should not need a rebuild
// and a deploy. Applied synchronously from cache so there is no flash.
applyTheme("vault");

export default mount(App, { target: document.getElementById("app")! });
